module.exports = "/assets/images/checkmark-long_f0787c.svg";